import { Box, Popper } from "@mui/material";
import { formatBitrateTime } from "../utils/bitrateHistory";

type StreamBitrateTooltipProps = {
  anchorEl: HTMLElement | null;
  active?: boolean;
  compact?: boolean;
  payload?: readonly {
    value?: unknown;
    payload?: { timestamp?: unknown };
  }[];
};

const StreamBitrateTooltip = ({ active, payload, anchorEl, compact = false }: StreamBitrateTooltipProps) => {
  const measurement = payload?.find((entry) => typeof entry.value === "number" && Number.isFinite(entry.value));
  const timestamp = measurement?.payload?.timestamp;
  if (!active || !anchorEl || !measurement || typeof timestamp !== "number" || !Number.isFinite(timestamp)) return null;

  return (
    <Popper
      open
      role="tooltip"
      anchorEl={anchorEl}
      placement="top"
      modifiers={[{ name: "offset", options: { offset: [0, 8] } }]}
      sx={{ zIndex: (theme) => theme.zIndex.tooltip, pointerEvents: "none" }}
    >
      <Box sx={{
        px: 0.75,
        py: 0.25,
        borderRadius: 1,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        color: "text.primary",
        fontSize: compact ? "0.65rem" : "0.75rem",
        whiteSpace: "nowrap",
      }}>
        {formatBitrateTime(timestamp)} · {Number(measurement.value).toFixed(2)} Mbit/s
      </Box>
    </Popper>
  );
};

export default StreamBitrateTooltip;
